"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs = __importStar(require("fs"));
const mkdirp = __importStar(require("mkdirp"));
const path = __importStar(require("path"));
const StringSeparator_1 = require("../../enums/StringSeparator");
const JavaScriptObfuscatorCLI_1 = require("../JavaScriptObfuscatorCLI");
class ObfuscatedCodeWriter {
    constructor(inputPath, options) {
        this.inputPath = inputPath;
        this.options = options;
    }
    getOutputCodePath(filePath) {
        const normalizedRawOutputPath = this.options.output
            ? path.normalize(this.options.output)
            : null;
        if (!normalizedRawOutputPath) {
            return path
                .normalize(filePath)
                .split(StringSeparator_1.StringSeparator.Dot)
                .map((value, index) => {
                return index === 0 ? `${value}${JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.obfuscatedFilePrefix}` : value;
            })
                .join(StringSeparator_1.StringSeparator.Dot);
        }
        const rawInputPathStats = fs.lstatSync(this.inputPath);
        const isDirectoryRawInputPath = rawInputPathStats.isDirectory();
        const isDirectoryRawOutputPath = path.extname(normalizedRawOutputPath) === '';
        if (isDirectoryRawInputPath) {
            if (isDirectoryRawOutputPath) {
                return path.join(normalizedRawOutputPath, filePath);
            }
            else {
                throw new Error('Output path for directory obfuscation should be a directory path');
            }
        }
        else {
            if (isDirectoryRawOutputPath) {
                return path.join(normalizedRawOutputPath, path.basename(filePath));
            }
            else {
                return normalizedRawOutputPath;
            }
        }
    }
    getOutputSourceMapPath(outputCodePath, sourceMapFileName = '') {
        if (sourceMapFileName) {
            outputCodePath = `${outputCodePath.substring(0, outputCodePath.lastIndexOf('/'))}/${sourceMapFileName}`;
        }
        if (!/\.js\.map$/.test(outputCodePath)) {
            outputCodePath = `${outputCodePath.split(StringSeparator_1.StringSeparator.Dot)[0]}.js.map`;
        }
        else if (/\.js$/.test(outputCodePath)) {
            outputCodePath += '.map';
        }
        return outputCodePath;
    }
    writeFile(outputPath, data) {
        mkdirp.sync(path.dirname(outputPath));
        fs.writeFileSync(outputPath, data, {
            encoding: JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.encoding
        });
    }
}
exports.ObfuscatedCodeWriter = ObfuscatedCodeWriter;
